<template>
  <div class="card__price">
    <span class="d-none d-md-inline" v-if="type === 'last-chance'">{{ trans.get('ms:shop.only') }}</span>
    {{ price }} €
    <span class="d-none d-md-inline" v-if="starter">{{ trans.get('ms:shop.for_one_package') }}</span>
  </div>
</template>

<script>

export default {
  name: 'ElementPrice',
  components: {},
  props: {
    price: String,
    type: String,
    starter: Boolean,
  },
  methods: {},
};
</script>
